<template>
  <c-modal-form
    :id="$getConst('FORM_MAIL_ORDER_MODAL_ID')"
    :loading="loading"
    :submit-btn-enabled="canSubmit"
    :error="error"
    fields-required
    title="Написать письмо менеджеру"
    @submit="submit()"
  >
    <form>
      <c-textarea
        v-model="text"
        :form-group="true"
        :row-count="5"
        placeholder="*Ваше сообщение"
      />
      <modal-files-upload
        id="mail-order"
        v-model="files"
        :max-files-size="$getConst('UPLOAD_MAX_FILES_SIZE')"
      />
    </form>
    <demo-denied />
  </c-modal-form>
</template>

<script>
import CModalForm from '../../../../../../../resources/js/components/ui/CModalForm'
import CTextarea from '../../../../../../../resources/js/components/ui/CTextarea'
import ModalFilesUpload from '../../../../../../../resources/js/components/ModalFilesUpload.vue'
import form from '../../../../../../../resources/js/mixins/form'
import modal from '../../../../../../../resources/js/mixins/modal'
import files from '../../../../../../../resources/js/mixins/files'
import apiService from '../../apiService'
import { mapGetters, mapState } from 'vuex'
import Notification from '../../../../../../../resources/js/notification'
import DemoDenied from '../DemoDenied'

/**
 * Модальное окно "Написать письмо менеджеру".
 */
export default {
  name: 'MailOrder',
  components: {
    DemoDenied,
    CModalForm,
    CTextarea,
    ModalFilesUpload
  },
  mixins: [form, modal, files],
  data () {
    return {
      text: '',
      files: []
    }
  },
  computed: {
    /**
     * Происходит ли загрузка или отправка данных.
     *
     * @returns {boolean}
     */
    loading () {
      return !!(this.sending || this.clientDomainsFetching)
    },
    /**
     * Может ли форма быть отправлена.
     *
     * @returns {boolean}
     */
    canSubmit () {
      return !!(this.text && this.domainSelected && this.isFilesSizeCorrect(this.files, this.$getConst('UPLOAD_MAX_FILES_SIZE')) && !this.isDemo)
    },
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      clientDomainsFetching: state => state.seo.client.domains.fetching
    }),
    ...mapGetters({
      isDemo: 'seo/client/info/isDemo'
    })
  },
  mounted () {
    $(`#${this.$getConst('FORM_MAIL_ORDER_MODAL_ID')}`).on('hidden.bs.modal', () => {
      this.resetState()
    })
  },
  methods: {
    /**
     * Сбрасывает данные формы.
     */
    resetState () {
      this.domain = ''
      this.text = ''
      this.files = []
      this.error = false
    },
    /**
     * Отправляет данные формы.
     */
    submit () {
      this.sending = true
      this.error = false

      apiService.postMailOrder(this.domainSelected, this.text, this.files)
        .then(() => {
          this.hideModal(this.$getConst('FORM_MAIL_ORDER_MODAL_ID'))
          this.resetState()

          this.sending = false

          Notification.notifySuccess({
            title: 'Данные отправлены'
          })
        })
        .catch(() => {
          this.sending = false

          this.error = true
        })
    }
  }
}
</script>
